import { PageEntityInterface } from '../types/base-entity-interface'
import {
  GlobalSettingsFontProperties,
  GoogleFontsGenerator,
} from './google-fonts-generator'

export class PageGoogleFontsGenerator extends GoogleFontsGenerator {
  public generateFonts(
    entities: PageEntityInterface[],
    globalSettings: GlobalSettingsFontProperties,
  ) {
    return super.generate(entities, {
      paragraph: globalSettings.fontFamily
        ? {
            fontFamily: globalSettings.fontFamily,
            fontStyle: globalSettings.fontStyle,
            fontWeight: globalSettings.fontWeight,
          }
        : undefined,
      heading: globalSettings.headingFontFamily
        ? {
            fontFamily: globalSettings.headingFontFamily,
            fontStyle: globalSettings.headingFontStyle,
            fontWeight: globalSettings.headingFontWeight,
          }
        : undefined,
    })
  }
}
